export enum Providers {
	META = 'meta',
	GOOGLE_ANALYTICS = 'google-analytics',
	SEGMENT = 'segment',
	TIKTOK = 'tiktok',
	MIXPANEL = 'mixpanel',
	AMPLITUDE = 'amplitude',
	CUSTOMER_IO = 'customerio',
	X = 'x',
	LINKEDIN = 'linkedin',
}

const providerIdNames: Record<Providers, string> = {
	[Providers.META]: 'Pixel ID',
	[Providers.GOOGLE_ANALYTICS]: 'Measurement ID',
	[Providers.SEGMENT]: 'Javascript Source ID',
	[Providers.TIKTOK]: 'Pixel ID',
	[Providers.MIXPANEL]: 'Project token',
	[Providers.AMPLITUDE]: 'API Key',
	[Providers.CUSTOMER_IO]: 'Site ID',
	[Providers.X]: 'Pixel ID',
	[Providers.LINKEDIN]: 'Insight tag partner ID',
};

export const getProviderIdName = (provider: Providers): string => providerIdNames[provider];
